'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./IyvBanner.css');

var IyvBanner = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(IyvBanner, _Component);

  function IyvBanner() {
    (0, _classCallCheck3.default)(this, IyvBanner);
    return (0, _possibleConstructorReturn3.default)(this, (IyvBanner.__proto__ || (0, _getPrototypeOf2.default)(IyvBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(IyvBanner, [{
    key: 'render',
    value: function render() {
      // const link = config.domain
      // const message = config.shareMessage

      var fffIcon = require('../../../static/images/icons/fff-icn-clr.png');
      var dffIcon = require('../../../static/images/icons/dff-icn-clr.png');
      var gefIcon = require('../../../static/images/icons/gef-icn-clr.png');
      var gffIcon = require('../../../static/images/icons/gff-icn-clr.png');
      var pffIcon = require('../../../static/images/icons/pff-icn-clr.png');
      var wffIcon = require('../../../static/images/icons/wff-icn-clr.png');
      var tffIcon = require('../../../static/images/icons/tff-icn-clr.png');
      var rpsIcon = require('../../../static/images/icons/rps-icn-clr.png');
      // rps = retirement plan scorecard

      var iconConfig = [{ icn: fffIcon, stl: 'fff', url: 'https://fossilfreefunds.org',
        name: 'Fossil Free Funds' }, { icn: dffIcon, stl: 'dff', url: 'https://deforestationfreefunds.org',
        name: 'Deforestation Free Funds' }, { icn: gefIcon, stl: 'gef', url: 'https://genderequalityfunds.org',
        name: 'Gender Equality Funds' }, { icn: gffIcon, stl: 'gff', url: 'https://gunfreefunds.org',
        name: 'Gun Free Funds' }, { icn: pffIcon, stl: 'pff', url: 'https://prisonfreefunds.org',
        name: 'Prison Free Funds' }, { icn: wffIcon, stl: 'wff', url: 'https://weaponfreefunds.org',
        name: 'Weapon Free Funds' }, { icn: tffIcon, stl: 'tff', url: 'https://tobaccofreefunds.org',
        name: 'Tobacco Free Funds' }, { icn: rpsIcon, stl: 'rps', url: 'https://investyourvalues.org',
        name: 'Retirement Plan Scorecard' }];

      // STYLE NOTES:
      // hmi == HomeMoreIyv
      return _react2.default.createElement(
        'div',
        { styleName: 'hmi-img-bckgrnd' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'hmi-hl' },
            'More from Invest Your Values'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'hmi-tl' },
            'See how mutual funds and ETFs are rated on issues ranging from fossil fuels, to deforestation, gender equality, guns, prisons, weapons, and tobacco'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'hmi-icns' },
            /* */
            iconConfig.map(function (e, i) {
              // some sites end in Funds others don't
              var nm = e.name.split(' ');
              var nmStart = nm.slice(0, 2).join(' ');
              var nmEnd = nm.slice(2);
              //
              return _react2.default.createElement(
                'div',
                {
                  styleName: 'hmi-icn-out',
                  key: 'hmi-icn-' + i
                },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: e.url,
                    title: e.name
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'hmi-icn-in' },
                    _react2.default.createElement('img', {
                      src: e.icn,
                      alt: e.name
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'hmi-icn-lbl' },
                      _react2.default.createElement(
                        'span',
                        { styleName: e.stl },
                        nmStart
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        '\xA0',
                        nmEnd
                      )
                    )
                  )
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'hmi-lnk' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.links.aysinvest,
                title: 'Learn more about Invest Your Values',
                xstrong: true
              },
              'Learn more about Invest Your Values',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    }
  }]);
  return IyvBanner;
}(_react.Component)) || _class);
exports.default = IyvBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvBanner/IyvBanner.js
// module id = 1316
// module chunks = 0